import { useEffect, useState } from "react";
import { AutocompleteCustom } from "../../../UI/AutoComplete/AutoComplete";
import { useTranslation } from "react-i18next";

export default function SelectOrganizationalUnits({
  returnValueFromSelect = () => null,
  OrganizationalUnits = [],
}) {
const [listOuForAutoComplete, setListOuForAutoComplete] = useState([]);
const { t } = useTranslation(); 
  useEffect(() => {
    let list = []
    OrganizationalUnits.map((value, index) => {
      list.push({ index: index, denominazione: value });
    });
    setListOuForAutoComplete(list)
  },[OrganizationalUnits])

  const handleValueOu = (selectedValue) => {
    returnValueFromSelect(selectedValue);
  };


  return (
    <>
      <AutocompleteCustom
        label={t("Organizational_Units")}
        field={["denominazione"]}
        checkField={"index"}
        keyId={"index"}
        multiple={true}
        optionsAutoComplete={listOuForAutoComplete}
        handleValueReturned={handleValueOu}
      />
    </>
  );
}
